export function info(message: string) {
    console.info(`[CheckoutStepManager] - ${message}`);
}

export function debug(message: string) {
    console.debug(`[CheckoutStepManager] - ${message}`);
}
